<div class="content">
  <div class="w-100 d-flex align-items-center gap--8">

    <input #attachmentInput style="display: none;" type="file" accept="image/*, video/*" (change)="addFile(); attachmentInput.value = ''">
    <app-icon 
      class="control-button attachment-button" 
      src="clip" 
      (click)="attachmentInput.click()" 
      [class.disabled]="disabled"
    ></app-icon>
    <form class="form">
      <textarea cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                [formControl]="messageInput"
                #textArea
                #autosize="cdkTextareaAutosize"
                placeholder="Type a question..."
                class="message-input hide-scrollbar"
                (keydown)="onKeyDown($event)"
      ></textarea>
    </form>
    <div class="d-flex gap--8 mb--2 send-button-wrap" #sendButton>
      <app-icon 
        class="control-button send-button" 
        src="send_message" 
        [class.disabled]="disabled || !hasNonWhitespaceChars(messageInput.value)" 
        (click)="sendMessage()"
      ></app-icon>
    </div>
  </div>

  <div class="divider-line"></div>

  <ng-content></ng-content>
</div>
